var ko = require('knockout');
var $ = require('jquery');

ko.components.register('choose-payer', {
  viewModel: require('./choose-payer'),
  template: require('./choose-payer.template')
});

$('[data-choose-payer]').each(function() {
  ko.applyBindings({}, this);
});
